export type CandleShape = {
  close: number;
  high: number;
  low: number;
};

export type CandleTransition = {
  from: CandleShape;
  to: CandleShape;
  startTime: number;
  duration: number;
};

export type ZoomedOutCandleStyle = {
  bodyWidth: number;
  wickWidth: number;
};

const clamp01 = (value: number): number => Math.max(0, Math.min(1, value));

export function sampleCandleTransition(
  transition: CandleTransition,
  now: number,
): { shape: CandleShape; done: boolean } {
  const progress = clamp01((now - transition.startTime) / transition.duration);
  const eased = 1 - Math.pow(1 - progress, 3);
  const interpolate = (from: number, to: number) => from + (to - from) * eased;

  return {
    shape: {
      close: interpolate(transition.from.close, transition.to.close),
      high: interpolate(transition.from.high, transition.to.high),
      low: interpolate(transition.from.low, transition.to.low),
    },
    done: progress >= 1,
  };
}

export function getZoomedOutCandleStyle(candleSpacing: number): ZoomedOutCandleStyle {
  const density = clamp01((4 - candleSpacing) / 3);
  const widthRatio = 0.8 - density * 0.25;
  const bodyWidth = Math.max(0.65, candleSpacing * widthRatio);

  return {
    bodyWidth,
    wickWidth: Math.min(bodyWidth * (0.8 - density * 0.25), 1.5 - density * 0.7),
  };
}
